import { useTranslation } from "react-i18next";
import LegalLayout from "../components/LegalLayout";

export default function Privacy() {
  const { t } = useTranslation();
  const sections = t("privacy.sections", { returnObjects: true }) as { title: string; body: string }[];
  const updated = t("privacy.updated");

  return (
    <LegalLayout
      eyebrow={t("privacy.eyebrow")}
      title={t("privacy.title")}
      subtitle={t("privacy.subtitle")}
      updated={updated}
      sections={sections}
    />
  );
}
